import { memo } from 'react';
import {
  VStack,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Text,
  Heading,
  Box,
} from '@chakra-ui/react';
import { questionAndAnswers } from 'constants/faq-questions';

const QuestionAnswers = () => {
  return (
    <VStack
      minH={'100vh'}
      gap="2em"
      h="max-content"
      py="5em"
      px={['1em', '2em', '3em']}
    >
      <VStack alignItems={'center'}>
        <Heading fontWeight={'extrabold'}>FAQs</Heading>
        <Text fontSize={'.9em'} color="#505050">
          Got questions about Vital Educators? Unpack your FAQs right here!
        </Text>
      </VStack>

      {Object.entries(questionAndAnswers).map(([title, value], idx) => (
        <VStack w="full" alignItems={'flex-start'} key={idx}>
          <Text fontSize="1.5em" fontWeight="extrabold">
            {title}
          </Text>
          <Accordion allowMultiple w="full">
            {value.map(({ question, answer }, idx) => (
              <AccordionItem key={idx}>
                <AccordionButton borderLeft={'2px solid blue'}>
                  <Box
                    flex="1"
                    textAlign="left"
                    fontSize={'1.2rem'}
                    fontWeight="600"
                    p={2}
                  >
                    {question}
                  </Box>
                  <AccordionIcon />
                </AccordionButton>

                <AccordionPanel p={4}>{answer}</AccordionPanel>
              </AccordionItem>
            ))}
          </Accordion>
        </VStack>
      ))}
    </VStack>
  );
};

export default memo(QuestionAnswers);
